import { render, staticRenderFns } from "./faulthour.vue?vue&type=template&id=6c3dc086&scoped=true&"
import script from "./faulthour.vue?vue&type=script&lang=js&"
export * from "./faulthour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3dc086",
  null
  
)

export default component.exports